export function localFormatter () {
  if (localStorage.pageCount) {
    return {
      pageCount: localStorage.pageCount,
      itemId: localStorage.itemId,
      currentCategory: localStorage.currentCategory,
      itemsPerPage: localStorage.itemsPerPage,
      filterParam: localStorage.filterParam
    };
  } else {
    return {
      pageCount: 1,
      itemId: false
    };
  }
}

export function elementPositioner (element) {
  window.scrollTo(0, $(element).offset().top + 10);
}

export function debounce (func, wait, immediate) {
  let timeout;

  return function () {
    const context = this;
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
